var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('st-header',{attrs:{"title":"我的工单","back-able":true}}),_c('div',{staticClass:"subCenter"},[_c('Submit1',{ref:"sub1",attrs:{"base-form-data":_vm.formData},on:{"next":_vm.next}}),_c('Submit2',{attrs:{"base-form-data":_vm.formData},on:{"prev":_vm.prev,"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }